// extracted by mini-css-extract-plugin
export default {"HubNavWrapper":"styles_HubNavWrapper__dfZGH","TLDCBadge":"styles_TLDCBadge__XfOOw","HubNav":"styles_HubNav__5ZFpj","currentPageLink":"styles_currentPageLink__JzPer"};